import { checkIsDisabledDay, getDateWithoutTime, getDaysInMonth, getDisabledTimestamps, getIsToday, toDate } from "../../../utils/date";

var fillEmptyDays = function fillEmptyDays(amount) {
  return new Array(amount).fill('empty').map(function () {
    return {
      date: null
    };
  });
};

var getEmptyDays = function getEmptyDays(dayIndex, firstDayOfWeek) {
  var result = [];

  if (firstDayOfWeek === 0 && dayIndex !== 0) {
    result = fillEmptyDays(dayIndex);
  } else if (firstDayOfWeek === 1) {
    if (dayIndex === 0) {
      result = fillEmptyDays(6);
    } else if (dayIndex > 1) {
      result = fillEmptyDays(dayIndex - 1);
    }
  }

  return result;
};

var isDayOfTheSameMonthAndYearAsMinMaxDate = function isDayOfTheSameMonthAndYearAsMinMaxDate(day, minDate, maxDate) {
  var year = day.getFullYear();
  var month = day.getMonth();
  return month === maxDate.getMonth() && year === maxDate.getFullYear() || month === minDate.getMonth() && year === minDate.getFullYear();
};

export var getCalendarData = function getCalendarData(_ref) {
  var minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      monthNames = _ref.monthNames,
      firstDayOfWeek = _ref.firstDayOfWeek,
      _ref$disabledDays = _ref.disabledDays,
      disabledDays = _ref$disabledDays === void 0 ? [] : _ref$disabledDays;
  var data = [];
  var timestampsByMonthKey = {};
  var monthAmount = 0;
  var monthNumberWithTodayDate;
  var minYear = toDate(minDate).getFullYear();
  var maxYear = toDate(maxDate).getFullYear();
  var minDateWithoutTime = getDateWithoutTime(minDate);
  var maxDateWithoutTime = getDateWithoutTime(maxDate);
  var disabledDaysTimestampMap = getDisabledTimestamps(disabledDays);

  for (var y = minYear; y <= maxYear; y += 1) {
    for (var m = 0; m <= 11; m += 1) {
      var month = {
        month: monthNames[m],
        year: y,
        weeks: []
      };
      timestampsByMonthKey[monthAmount] = new Set();
      var daysInMonth = getDaysInMonth(m + 1, y);
      var emptyDays = new Date(y, m).getDay();
      var week = getEmptyDays(emptyDays, firstDayOfWeek);
      var countDayInMonth = 0;

      for (var d = 1; d <= daysInMonth; d += 1) {
        var date = new Date(y, m, d, 0, 0, 0, 0);
        var day = {};

        if (date >= minDateWithoutTime && date <= maxDateWithoutTime) {
          day.date = date;

          if (checkIsDisabledDay(disabledDaysTimestampMap, date)) {
            day.isDisabled = true;
          }

          week.push(day);
          countDayInMonth += 1;
          timestampsByMonthKey[monthAmount].add(date.getTime());
        } else if (isDayOfTheSameMonthAndYearAsMinMaxDate(date, minDateWithoutTime, maxDateWithoutTime)) {
          day.date = date;
          day.isDisabled = true;
          week.push(day);
          countDayInMonth += 1;
          timestampsByMonthKey[monthAmount].add(date.getTime());
        }

        if (week.length === 7 || d === daysInMonth) {
          var isEmptyWeek = week.every(function (item) {
            return item.date === null;
          });

          if (!isEmptyWeek) {
            month.weeks.push(week);
          }

          week = [];
        }

        if (getIsToday(date)) {
          monthNumberWithTodayDate = monthAmount;
        }
      }

      if (countDayInMonth) {
        data.push(month);
      }

      if (month.weeks.length) {
        monthAmount += 1;
      }
    }
  }

  return {
    data: data,
    monthNumberWithTodayDate: monthNumberWithTodayDate,
    timestampsByMonthKey: timestampsByMonthKey,
    disabledDaysTimestampMap: disabledDaysTimestampMap
  };
};